<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon
          v-if="bankDetail.payment_method_id"
          color="primary"
        >
          mdi-pencil
        </v-icon>

        <v-icon
          v-else
          color="hrissecondary"
        >
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Employee Bank Detail"
      :text="bankDetail.payment_method_id ? 'Update employee bank detail':'Create employee bank detail'"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="paymentMethod"
                v-validate="'required'"
                label="Payment Method"
                :items="paymentMethods"
                item-text="name"
                item-value="id"
                :error-messages="errors.collect('paymentMethod')"
                data-vv-name="paymentMethod"
                data-vv-as="payment method"
                @change="clearBankAccountNumber"
              />
            </v-col>

            <v-col
              v-if="paymentMethod && (paymentMethod != 2)"
              cols="12"
            >
              <v-autocomplete
                v-model="bank"
                v-validate="'required'"
                label="Bank"
                :items="filteredBanks"
                item-text="name"
                item-value="id"
                :error-messages="errors.collect('bank')"
                data-vv-name="bank"
                data-vv-as="bank"
              />
            </v-col>

            <v-col
              v-if="paymentMethod && (paymentMethod != 2)"
              cols="12"
            >
              <v-text-field
                v-model="bankAccountNumber"
                v-validate="'required'"    
                :error-messages="errors.collect('bankAccountNumber')"
                data-vv-name="bankAccountNumber"
                data-vv-as="bank account number"
                label="Bank Account Number"
              />
            </v-col>
          </v-row>
        </v-container> 
      </form> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>  
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      bankDetail: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        loading: false,
        paymentMethod: null,
        paymentMethods: [],
        bank: null,
        banks: [],
        bankAccountNumber: null,
      }
    },
    computed: {
      filteredBanks () {
        if (!this.banks) return []

        if (this.paymentMethod === 4) {
          // Return only E-Wallet banks
          return this.banks.filter(bank => bank.type === 'E-Wallet')
        }

        // Return non-E-Wallet banks
        return this.banks.filter(bank => bank.type !== 'E-Wallet')
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.paymentMethod = this.bankDetail.payment_method_id
        this.bank = this.bankDetail.bank_uid
        this.bankAccountNumber = this.bankDetail.bank_account_number

        Promise.all([
          this.$api.paymentMethods().list(),
          this.$api.payrollBanks().list(),
        ])
          .then(([paymentMethod, payrollBank]) => {
            this.paymentMethods = _.orderBy(paymentMethod.data, ['name'], ['asc'])
            this.banks = _.orderBy(payrollBank.data, ['name'], ['asc'])

            this.loading = false
          })
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.employeePayrollBanks().update(this.employeeUid, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          bank_uid: this.bank,
          bank_account_number: this.bankAccountNumber,
          payment_method_id: this.paymentMethod,
        }
      },
      clearBankAccountNumber () {
        if (this.paymentMethod === 2) {
          this.bankAccountNumber = null
          this.bank = null
        }
      },
    },
  }
</script>
